import { useEffect, useState } from 'react';

// Callback will be called automatically when value has not been changed during delay, to change the value use returned setter
export function useDebouncedCallback<T>(initialState: T, callback: (v: T | undefined) => void, delay: number) {
  const [value, setValue] = useState<T>(initialState);
  useEffect(() => {
    const timer = setTimeout(() => {
      callback(value);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [callback, delay, value]);
  return [value, setValue] as const;
}
